import React from "react";
import { useNavigation } from "@react-navigation/native";
import {
  Text,
  TouchableOpacity,
  View,
  Image,
  ImageBackground,
} from "react-native";
import { FormattedMessage } from "react-intl";
import styles from "./styles";

const StampsCalculatorCard = () => {
  const navigation = useNavigation();
  return (
    <ImageBackground
      source={require("../../../assets/bg-calculadora-card.png")}
      style={styles.mainContainer}
    >
      <View style={styles.rowContainer}>
        <Image
          source={require("../../../assets/calculadora-icon.png")}
          style={styles.logoCalculadora}
        />
        <View style={styles.textContainer}>
          <Text style={styles.txtTitle}>
            <FormattedMessage id="stampsCalculatorCard.txtTitle" />
          </Text>
          <Text style={styles.txtDescricao}>
            <FormattedMessage id="stampsCalculatorCard.infoText" />
          </Text>
        </View>
      </View>
      <TouchableOpacity
        onPress={() => navigation.navigate("StampsCalculator")}
        style={styles.btnCalcular}
      >
        <Text style={styles.txtBtnCalcular}>
          <FormattedMessage id="stampsCalculatorCard.btnCalculeSuasEmissoes" />
        </Text>
      </TouchableOpacity>
    </ImageBackground>
  );
};

export default StampsCalculatorCard;
